export default __webpack_public_path__ + "static/media/logo.5f5b23a3.svg";